module.exports = __webpack_public_path__ + "media/images/front/marker-cb252ab9bac088f6acfa52081184ee9d.png";